const names = {
  REQUEST_BRAND_META_DATA: 'REQUEST_BRAND_META_DATA_COMPETITOR',
  RECEIVE_BRAND_META_DATA: 'RECEIVE_BRAND_META_DATA_COMPETITOR',
  FAILURE_BRAND_META_DATA: 'FAILURE_BRAND_META_DATA_COMPETITOR'
};

export default names;
